<template>
	<CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
			<div class="container-fluid">
				<form id="FormProducto" role="form" method="post" autocomplete="off" onSubmit="return false">	
					
					<div class="row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<div class="avatar-upload">
								<div class="avatar-edit">
									<input type="file" @change="$uploadImagePreview($event,ValidElement, Array('Img','imagePreview'))" id="file" name="file" ref="fileImg" accept=".png, .jpg, .jpeg">
									<label for="file"></label>
								</div>
								<div class="avatar-preview">
									<div id="imagePreview" :style="'background-image: url('+RutaFile+objProducto.UrlImagen+objProducto.NombreImagen+')'" :src="RutaFile+objProducto.UrlImagen+objProducto.NombreImagen">
									</div>
								</div>
							</div>
						</div>
					</div>

					<br>

					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Nombre">Nombre del Producto</label>
							<input type="text" v-model="objProducto.Nombre" class="form-control" id="Nombre" placeholder="Ingresar Nombre del Producto" />
							<CValidation v-if="this.errorvalidacion.Nombre" :Mensaje="'*'+errorvalidacion.Nombre[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
							<label class="form-label" for="Costo">Costo</label>
							<input disabled type="text" v-model="objProducto.Costo" class="form-control" id="Costo" placeholder="Ingresar Costo" />
							<CValidation v-if="this.errorvalidacion.Costo" :Mensaje="'*'+errorvalidacion.Costo[0]"/>
						</div>

						<div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
							<label class="form-label" for="IdArticuloCategoria">Categoría del Producto</label>
							<select v-model="objProducto.IdArticuloCategoria" class="form-control-search form-select" id="IdArticuloCategoria">
								<option value="0">Seleccione una opción</option>
								<option v-for="(item, index) in Categorias" :key="index" :value="item.IdArticuloCategoria">{{item.Nombre}}</option>
							</select>
							<CValidation v-if="this.errorvalidacion.IdArticuloCategoria" :Mensaje="'*'+errorvalidacion.IdArticuloCategoria[0]"/>
						</div>
						
					</div>
											
					<br>
				
				</form>
			</div>
		</template>
	</CLoader>
</template>

<script>
import Configs from '@/helpers/VarConfig.js';
export default {
    name: 'FormProducto',
    props: ['poBtnSave'],
    components:{
    },
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objProducto: {
				IdProducto: 0,
				IdArticuloCategoria: 0,
				Nombre: '',
				NombreImagen:'',
				UrlImagen:'',
				Costo: 0,
				
            },
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
			//masks:{ input: 'YYYY-MM-DD'}, // quitar sino lleva fecha
			Categorias: [],
			ValidElement: Configs.validImage3m,
			RutaFile: '',
            Img: null,
        }
    },
    methods :
    {
       	async Guardar()
        {
			let formData = new FormData();
            let Imagen = this.$refs.fileImg.files[0];

            // if(Imagen === undefined && this.objProducto.IdProducto == 0){
            //     this.$toast.warning('Debe agregar una imagen');
            //     return false;
            // }
			formData.set('IdProducto',this.objProducto.IdProducto);
			formData.set('Nombre',this.objProducto.Nombre);
			formData.set('IdArticuloCategoria',this.objProducto.IdArticuloCategoria);
			formData.set('Costo',this.objProducto.Costo);
			formData.set('TipoImagen','Producto');
			formData.append('Imagen',Imagen);

			this.errorvalidacion = [];
            this.poBtnSave.Toast = 0; 
            this.poBtnSave.DisableBtn = true;

			await this.$http.post(
				'productos',formData,{
					headers:{
						'Content-Type':'multipart/form-data'
					}
				}
			).then((res)=>{
				this.EjecutaConExito(res);
			}).catch(err=>{   
				this.EjecutaConError(err);
			});
        },
		EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		Recuperar()
        {
            this.$http.get(
                "productos/"+this.objProducto.IdProducto
            ).then((res) => {
                this.objProducto = res.data.data;
				this.RutaFile = res.data.RutaFile;

            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            this.objProducto = {
				IdProducto: 0,
				IdArticuloCategoria: 0,
				Nombre: '',
				Costo: 0,
				IdEmpresa: 0,
				IdSucursal: 0,
				NombreImagen:'',
				UrlImagen:''
            }
            this.errorvalidacion = [];
        },
		ListaCategorias()
		{
			this.$http.get('articulosCategoria', {
                params: {
                    simple: 1,
                    TipoCategoria: 'Producto',
                }
            }).then((res) =>
            {
                this.Categorias = res.data.data;
            });
		},
    },
    created() {
		this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;
			this.ListaCategorias();

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();
                
            if (Id!='') 
            {
                this.objProducto.IdProducto = Id;
                this.Recuperar();
            }
            else
            {
                this.ConfigLoad.ShowLoader = false;
            }
        });
    }
}
</script>
